export const ATTENDANCE_PWA = {
  id: "attendance",
  manifestHref: "/manifest.json",
  appleTouchIcon: "/icons/apple-touch-icon.png",
  themeColor: "#438a8c",
  appleWebAppTitle: "Attendance",
  name: "Attendance",
  installTitle: "Install Attendance App",
};

export const ADMIN_PWA = {
  id: "admin",
  manifestHref: "/manifest-super-admin.json",
  appleTouchIcon: "/icons/admin/apple-touch-icon.png",
  themeColor: "#0f172a",
  appleWebAppTitle: "Admin Console",
  name: "Admin Console",
  installTitle: "Install Admin Console",
};

export function getPwaConfig(appId) {
  return appId === "admin" ? ADMIN_PWA : ATTENDANCE_PWA;
}
